import { UIRouterReact } from '@uirouter/react';
import { sessionStateService } from '@logz-pkg/frontend-services';
import { userHistoryStateService } from 'ui/state/user-history.state.service';
import { getProductForState } from 'ui/components/App/Navigation/utils';

export const registerHistoryTracking = (appRouter: UIRouterReact) => {
  appRouter.transitionService.onSuccess({}, transition => {
    const session = sessionStateService.session.get();

    if (!session?.loggedInUser) {
      return;
    }

    const { appMode } = session;
    const from = transition.from().name;
    const to = transition.to().name;

    if (!from || !to || !appMode?.value) return;

    const fromProduct = getProductForState({ state: from, appMode: appMode.value, stateParams: {} });
    const toProduct = getProductForState({ state: to, appMode: appMode.value, stateParams: {} });

    if (fromProduct) {
      userHistoryStateService.trackEvent(fromProduct);
    }

    if (toProduct) {
      userHistoryStateService.trackEvent(toProduct);
    }
  });
};
